import React, { useEffect } from "react";
import Layout from "./common/Layout";

const TermsConditions = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
        <section className="py-5 bg-light-primary">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h1 className="display-4 fw-bolder text-primary-s mb-4 wow animated fadeInDown">Terms & Conditions</h1>
                <span className="sep mt-4 mx-auto d-block wow animated fadeInUp"></span>
                <p className="lead text-muted mt-4 wow animated fadeInUp">Please read these terms carefully before using our service</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="privacy-content">
                  <div className="mb-5">
                    <p className="lead line-h-170">
                      Welcome to FloridaDrivingPermit.com. By using our website and enrolling in the TLSAE course, you agree to the following terms and conditions:
                    </p>
                  </div>

                  <div className="privacy-section mb-5">
                    <h3 className="h4 fw-bold text-primary-s mb-3 d-flex align-items-center">
                      <span className="box-icon me-3">
                        <i className="fa fa-user-check"></i>
                      </span>
                      1. Course Eligibility
                    </h3>
                    <div className="ps-5">
                      <ul className="list-unstyled">
                        <li className="d-flex gap-2 align-items-start py-2">
                          <i className="fa fa-check text-primary-s mt-1"></i>
                          <span>This course is for first-time driver license applicants in the state of Florida.</span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                          <i className="fa fa-check text-primary-s mt-1"></i>
                          <span>By enrolling, you confirm that <b>you are the person taking the course</b> and will complete it independently.</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="privacy-section mb-5">
                    <h3 className="h4 fw-bold text-primary-s mb-3 d-flex align-items-center">
                      <span className="box-icon me-3">
                        <i className="fa fa-graduation-cap"></i>
                      </span>
                      2. Course Format and Completion
                    </h3>
                    <div className="ps-5">
                      <ul className="list-unstyled">
                        <li className="d-flex gap-2 align-items-start py-2">
                          <i className="fa fa-angle-right text-primary-s mt-1"></i>
                          <span>The TLSAE course is <b>entirely online</b> and takes a <b>minimum of 4 hours</b> to complete.</span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                          <i className="fa fa-angle-right text-primary-s mt-1"></i>
                          <span>You must pass a <b>40-question exam with at least 80% accuracy</b> to receive your course completion certificate.</span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                          <i className="fa fa-angle-right text-primary-s mt-1"></i>
                          <span>Course completion is reported directly to the <b>Florida HSMV</b>.</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="privacy-section mb-5">
                    <h3 className="h4 fw-bold text-primary-s mb-3 d-flex align-items-center">
                      <span className="box-icon me-3">
                        <i className="fa fa-credit-card"></i>
                      </span>
                      3. Payments and Refunds
                    </h3>
                    <div className="ps-5">
                      <ul className="list-unstyled">
                        <li className="d-flex gap-2 align-items-start py-2">
                        <i className="fa fa-angle-right text-primary-s mt-1"></i>
                        <span>All payments are securely processed through <b>Stripe</b>.</span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                        <i className="fa fa-angle-right text-primary-s mt-1"></i>
                        <span>We do <b>not store your credit card information</b> on our servers.</span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                        <i className="fa fa-angle-right text-primary-s mt-1"></i>
                        <span>Refunds are <b>not issued</b> for failed exams or course failures due to identity or participation violations.</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="privacy-section mb-5">
                    <h3 className="h4 fw-bold text-primary-s mb-3 d-flex align-items-center">
                      <span className="box-icon me-3">
                        <i className="fa fa-redo"></i>
                      </span>
                      4. Retake Policy
                    </h3>
                    <div className="ps-5">
                      <ul className="list-unstyled">
                        <li className="d-flex gap-2 align-items-start py-2">
                        <i className="fa fa-angle-right text-primary-s mt-1"></i>
                          <span>If you do not pass the initial test, you may <b>retake the exam once.</b></span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                        <i className="fa fa-angle-right text-primary-s mt-1"></i>
                          <span>If you fail the retake, you may <b>re-enroll</b> in the course, subject to additional fees.</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="privacy-section mb-5">
                    <h3 className="h4 fw-bold text-primary-s mb-3 d-flex align-items-center">
                      <span className="box-icon me-3">
                        <i className="fa fa-user-shield"></i>
                      </span>
                      5. Data Privacy
                    </h3>
                    <div className="ps-5">
                      <ul className="list-unstyled">
                        <li className="d-flex gap-2 align-items-start py-2">
                        <i className="fa fa-angle-right text-primary-s mt-1"></i>
                          <span>We respect your privacy and do <b> not sell, trade, or share your personal information</b>.</span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                        <i className="fa fa-angle-right text-primary-s mt-1"></i>
                          <span>Personal data is used <b>solely to verify your identity</b>, track your progress, and report results to the <b>Florida HSMV</b>.</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="privacy-section mb-5">
                    <h3 className="h4 fw-bold text-primary-s mb-3 d-flex align-items-center">
                      <span className="box-icon me-3">
                        <i className="fa fa-balance-scale"></i>
                      </span>
                      6. Course Integrity
                    </h3>
                    <div className="ps-5">
                      <ul className="list-unstyled">
                        <li className="d-flex gap-2 align-items-start py-2">
                        <i className="fa fa-angle-right text-primary-s mt-1"></i>
                          <span>You agree to <b>not share course content</b>, attempt to bypass validation, or engage in cheating.</span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                        <i className="fa fa-angle-right text-primary-s mt-1"></i>
                          <span>Identity verification questions are <b>mandatory</b> and <b>failure to comply</b> will result in course failure without a refund.</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="privacy-section mb-5">
                    <h3 className="h4 fw-bold text-primary-s mb-3 d-flex align-items-center">
                      <span className="box-icon me-3">
                        <i className="fa fa-laptop"></i>
                      </span>
                      7. Technology Requirements
                    </h3>
                    <div className="ps-5">
                      <ul className="list-unstyled">
                        <li className="d-flex gap-2 align-items-start py-2">
                        <i className="fa fa-angle-right text-primary-s mt-1"></i>
                          <span>You are responsible for having a stable internet connection and compatible device to complete the course.</span>
                        </li>
                        <li className="d-flex gap-2 align-items-start py-2">
                            <i className="fa fa-angle-right text-primary-s mt-1"></i>
                          <span>The course is mobile-friendly and allows you to log in and resume progress at any time.</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="privacy-section mb-5">
                    <h3 className="h4 fw-bold text-primary-s mb-3 d-flex align-items-center">
                      <span className="box-icon me-3">
                        <i className="fa fa-edit"></i>
                      </span>
                      8. Modifications
                    </h3>
                    <div className="ps-5">
                      <p className="line-h-170">
                        We may update these terms periodically. Continued use of the site means you accept any updates.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    </Layout>
  );
};

export default TermsConditions;
